import { render, staticRenderFns } from "./CreateEmailTemplate.vue?vue&type=template&id=f0b79fb8"
import script from "./CreateEmailTemplate.vue?vue&type=script&lang=js"
export * from "./CreateEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports